import { isAxiosError } from 'axios'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { GoogleOAuthProvider } from '@react-oauth/google'

import { GOOGLE_CLIENT_ID } from '@pepper/utils/src/api/config'
import { HttpStatus } from '@pepper/utils/src/constant/enum/status_code'

/* main router */
import Routes from './router'

import {
  AuthProvider,
  GlobalStateProvider,
  MessageProvider,
  UtilsProvider,
} from '@pepper/ui'
import { Helmet } from 'react-helmet'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        const MAX_RETRIES = 3
        const HTTP_STATUS_TO_NOT_RETRY = [
          HttpStatus.BadRequest,
          HttpStatus.Unauthorized,
          HttpStatus.Forbidden,
          HttpStatus.NotFound,
        ]
        if (failureCount > MAX_RETRIES) {
          return false
        }

        if (
          isAxiosError(error) &&
          error.response?.status &&
          HTTP_STATUS_TO_NOT_RETRY.includes(error.response.status)
        ) {
          return false
        }

        return true
      },
    },
  },
})

const App = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />

        <GlobalStateProvider>
          <MessageProvider>
            <AuthProvider>
              <UtilsProvider>
                <Helmet
                  titleTemplate="%s - Pepper Content"
                  defaultTitle="Operations Platform | Pepper"
                />
                <Routes />
              </UtilsProvider>
            </AuthProvider>
          </MessageProvider>
        </GlobalStateProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  )
}

export default App
